var map = {
	"./asbest.jpg": 5476,
	"./asfalt.jpg": 402,
	"./asfalt.svg": 3326,
	"./batterier.jpg": 3216,
	"./beton-og-natursten.jpg": 7424,
	"./bilbatterier.jpg": 89,
	"./bloed-plast.jpg": 5696,
	"./boeger.jpg": 2217,
	"./brokker.jpg": 3632,
	"./daek.jpg": 5844,
	"./deponi.jpg": 3720,
	"./drikkedaaser.jpg": 2297,
	"./elpaerer.jpg": 4171,
	"./farligt-affald.png": 812,
	"./fladskaerme-og-baerbare.jpg": 4272,
	"./flamingo.jpg": 525,
	"./gips.jpg": 1270,
	"./glas.jpg": 7759,
	"./haard-pvc.jpg": 197,
	"./haveaffald.jpg": 4048,
	"./icon-asfalt.jpg": 5731,
	"./indendoers-trae.jpg": 137,
	"./jern-og-metal.jpg": 378,
	"./jord.jpg": 7122,
	"./koeleskabe-frysere.jpg": 5517,
	"./komfurer-vaskemaskiner.jpg": 2546,
	"./ledninger-og-kabler.jpg": 2937,
	"./lysstofroer.jpg": 9204,
	"./mad-og-drikkekartoner.png": 8004,
	"./mellemstort-elektronik-50-120cm.jpg": 8596,
	"./mursten-og-tegl.jpg": 767,
	"./natur.jpg": 704,
	"./paller.jpg": 6920,
	"./pap.jpg": 7255,
	"./papir-aviser.jpg": 1427,
	"./papir-og-aviser.jpg": 1374,
	"./papir-til-makulering.jpg": 8470,
	"./pet-flasker.jpg": 4025,
	"./plasthavemoebler.jpg": 131,
	"./printerpatroner.jpg": 9413,
	"./rockwool-og-glasuld.jpg": 7171,
	"./skaerme-med-billedroer.jpg": 5904,
	"./smaat-elektronik-u-50cm.jpg": 4081,
	"./tagpap.jpg": 2655,
	"./tekstiler.jpg": 5730,
	"./toiletter-og-haandvaske.jpg": 6159,
	"./trykflasker.jpg": 3148,
	"./udendoers-trae.jpg": 8925,
	"./vinduer.jpg": 3939
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7910;